import axios from 'axios';
import { Env } from '@/configuration';
import { MatchDay, Match, SaveMatchPayload } from './models';

const fetchMatchDays = async () => {
  const matchDaysUrl = Env.AdminApiOptions.endpointUrl('schedule/matchDays');

  const response = await axios.get(matchDaysUrl);
  const result: MatchDay[] = response && response.data;
  return result;
};

const fetchMatchDayMatches = async (matchDayId: number) => {
  const matchDayMatchesUrl = Env.AdminApiOptions.endpointUrl(`schedule/matchDays/${matchDayId}/matches`);

  const response = await axios.get(matchDayMatchesUrl);
  const result: Match[] = response && response.data;
  return result;
};

const saveMatch = async (payload: SaveMatchPayload) => {
  const saveMatchUrl = Env.AdminApiOptions.endpointUrl('matches');
  const saveAction = payload.id == null
    ? () => axios.post(saveMatchUrl, payload)
    : () => axios.put(saveMatchUrl, payload);

  const response = await saveAction();
  const result: any = response && response.data;

  return result;
};

const deleteMatch = async (matchId: number) => {
  const deleteUrl = Env.AdminApiOptions.endpointUrl(`matches/${matchId}`);

  const response = await axios.delete(deleteUrl);
  const result: any = response && response.data;

  return result;
};

const fetchDataFromLaczyNasPilka = async (matchDayId: number) => {
  const fetchDataFromLaczynaspilkaUrl = Env.AdminApiOptions.endpointUrl(`schedule/matchDays/${matchDayId}/fetch-data-from-laczynaspilka`);

  const response = await axios.post(fetchDataFromLaczynaspilkaUrl);
  const result: any = response && response.data;

  return result;
};


export default {
  saveMatch,
  fetchMatchDays,
  fetchMatchDayMatches,
  deleteMatch,
  fetchDataFromLaczyNasPilka,
};
